<template>
  <v-dialog v-model="dialog" width="620px">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn depressed color="primary">
          <v-icon left>add</v-icon>
          {{ `Thêm kỳ ${titleType}` }}
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title class="text-uppercase">THÊM KỲ {{ titleType }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="mt-6">
        <v-form ref="form" flat v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6" class="style1">
              <v-autocomplete
                v-model="period"
                clear-icon="mdi-close"
                :items="sortPeriods"
                item-text="title"
                v-bind:label="`Kỳ ${titleType}`"
                placeholder="Tháng --/----"
                clearable
                outlined
                dense
                return-object
                :rules="[rules.required, isPeriod]"
              />
            </v-col>
            <v-col cols="12" v-if="groupHeadFee.scope === 'group' && inputToggle" class="style">
              <v-divider />
              <v-radio-group v-model="type" class="small-radio" row :rules="[rules.required]">
                <v-radio label="Theo mức phí cụ thể" value="fixed" />
                <v-radio label="Theo phần trăm khoản phí" value="percentage" />
              </v-radio-group>
            </v-col>
            <v-col cols="6" v-if="groupHeadFee.scope === 'group'">
              <v-text-field
                :value="price"
                @input="handlePrice"
                v-bind:label="changeTextInput"
                v-bind:placeholder="changeTextInput"
                clearable
                outlined
                dense
                return-object
                :rules="[rules.required, rules.isNumber, regexTestPercentage]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel">
          Hủy
        </v-btn>
        <v-spacer />
        <v-btn depressed class="px-6 mr-4 mt-n4 mb-2 white--text" :loading="loading" color="primary" @click="save">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { inputRules } from '@/plugins/rule'
import { mapActions, mapState } from 'vuex'
import { sortPeriod, getPriceInputPlaceholder } from '../utils'

export default {
  props: {
    groupHeadFee: Object,
    prices: Array
  },
  data() {
    return {
      dialog: false,
      loading: false,
      period: '',
      price: '',
      type: 'fixed',
      rules: inputRules,
      valid: true
    }
  },
  created() {
    this.fetchPeriods()
  },
  computed: {
    ...mapState('salaryHead', ['router', 'isSubFee', 'headFee']),
    ...mapState('salaryPeriod', ['periods']),
    titleType() {
      if (this.router === 'main') return 'chi'
      return this.$route.meta.title.replace('Chi tiết', '')
    },
    changeTextInput() {
      return getPriceInputPlaceholder(this.router, this.isSubFee, this.type)
    },
    sortPeriods() {
      return sortPeriod(this.periods)
    },
    inputToggle() {
      if (this.groupHeadFee.scope === 'group' && this.router !== 'main') {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('salaryHead', ['createPriceGroupHeadFee', 'fetchGroupHead']),
    ...mapActions('salaryPeriod', ['fetchPeriods']),
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
    handlePrice(value) {
      if (value) {
        let number = value.split(/\s*,\s*/).join('')
        this.price = (+number).toLocaleString('en-US')
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    regexTestPercentage(number) {
      return !(this.type === 'percentage' && +number > 100) || !number || 'Phần trăm tối đa 100%'
    },
    isPeriod(period) {
      if (!period) return true
      if (!this.prices.find(price => price.period.title === period.title)) return true
      if (this.router === 'main') return 'Kỳ chi này đã tồn tại'
      if (this.router === 'adjust') return 'Kỳ điều chỉnh này đã tồn tại'
      if (this.isSubFee) return 'Kỳ hoàn trả này đã tồn tại'
      return 'Kỳ truy thu này đã tồn tại'
    },
    async save() {
      this.loading = true
      if (this.validate()) {
        try {
          let payload = {
            groupHeadFeeId: this.groupHeadFee.id,
            price: {
              price: this.price.split(/\s*,\s*/).join(''),
              type: this.type,
              period: this.period.id
            }
          }
          await this.createPriceGroupHeadFee(payload)
          await this.fetchGroupHead(this.$route.params.id)
          this.loading = false
          this.$alert.addSuccess(`kỳ ${this.titleType}`)
          this.dialog = false
          this.$refs.form.reset()
          this.type = 'fixed'
        } catch (error) {
          this.$alert.updateError({
            title: 'Lỗi thao tác',
            description: `Không thể thêm mới kỳ ${this.titleType}. Vui lòng thử lại`
          })
        }
      }
      this.loading = false
    }
  },
  watch: {
    price() {
      new Intl.NumberFormat('vi-VN').format(this.price)
    }
  }
}
</script>
<style lang="scss" scoped>
.data-picker,
.text-field {
  width: 280px;
}
.style {
  margin-bottom: -15px !important;
}
.style1 {
  margin-bottom: -19px !important;
}
</style>
